export function Edit({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.25 2.00903H6.75C3 2.00903 1.5 3.50903 1.5 7.25903V11.759C1.5 15.509 3 17.009 6.75 17.009H11.25C15 17.009 16.5 15.509 16.5 11.759V10.259"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0299 2.77422L6.11991 8.68422C5.89491 8.90922 5.66991 9.35172 5.62491 9.67422L5.30241 11.9317C5.18241 12.7492 5.75991 13.3192 6.57741 13.2067L8.83491 12.8842C9.14991 12.8392 9.59241 12.6142 9.82491 12.3892L15.7349 6.47922C16.7549 5.45922 17.2349 4.27422 15.7349 2.77422C14.2349 1.27422 13.0499 1.75422 12.0299 2.77422Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.1826 3.62183C11.6851 5.41433 13.0876 6.81683 14.8876 7.32683"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
